<template>
  <mdb-container fluid>
    <banner-small :group="currentGroup" title="Accounting" v-if="currentGroup"/>
    <div v-if="dashboardData && userDetails && showDashboard">
      <section>
        <!--Grid row-->
        <mdb-row>
          <!--Grid column-->
          <mdb-col class="mb-4" md="6" :xl="topBoxSize" v-if="!settings.disableGroupSubscriptions">
            <!--Card-->
            <mdb-card>
              <!--Card Data-->
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="3" md="5">
                  <mdb-btn class="ml-4" color="warning" floating size="lg" tag="a"
                           type=""
                  >
                    <mdb-icon aria-hidden="true" icon="file-invoice"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-4" col="9" md="7">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">{{dashboardData.subscriptionCharges}}</h5>
                  <p class="font-small grey-text">Subscription Charges</p>
                </mdb-col>
              </mdb-row>
              <!--/.Card Data-->
            </mdb-card>
            <!--/.Card-->
          </mdb-col>
          <!--Grid column-->

          <!--Grid column-->
          <mdb-col class="mb-4" :xl="topBoxSize" md="6">
            <!--Card-->
            <mdb-card>
              <!--Card Data-->
              <mdb-row class="mt-3">
                <mdb-col class=" text-left pl-4" col="5" md="5">
                  <mdb-btn class="ml-4" color="success" floating size="lg" tag="a"
                           type=""
                  >
                    <mdb-icon aria-hidden="true" icon="ticket"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class=" text-right pr-5" col="7" md="7">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">{{dashboardData.eventCharges}}</h5>
                  <p class="font-small grey-text">{{ capitalize($tc("common.label.event",1)) }} Charges</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
            <!--/.Card-->
          </mdb-col>
          <!--Grid column-->

          <!--Grid column-->
          <mdb-col class="mb-4" md="6" :xl="topBoxSize">
            <!--Card-->
            <mdb-card>
              <!--Card Data-->
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 lighten-1"
                    color="red"
                    floating
                    size="lg"
                    type=""
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="minus"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">{{dashboardData.expenses}}</h5>
                  <p class="font-small grey-text">Expenses</p>
                </mdb-col>
              </mdb-row>

            </mdb-card>
            <!--/.Card-->
          </mdb-col>
          <!--Grid column-->

          <!--Grid column-->
          <mdb-col class="mb-4" md="6" :xl="topBoxSize">
            <!--Card-->
            <mdb-card>
              <!--Card Data-->
              <mdb-row class="mt-3">
                <mdb-col class="text-left pl-4" col="5" md="5">
                  <mdb-btn
                    class="ml-4 accent-2"
                    color="light-blue"
                    floating
                    type=""
                    size="lg"
                    tag="a"
                  >
                    <mdb-icon aria-hidden="true" icon="plus"
                    />
                  </mdb-btn>
                </mdb-col>

                <mdb-col class="text-right pr-5" col="7" md="7">
                  <h5 class="ml-4 mt-4 mb-2 font-weight-bold">{{dashboardData.income}}</h5>
                  <p class="font-small grey-text">Income</p>
                </mdb-col>
              </mdb-row>
            </mdb-card>
            <!--/.Card-->
          </mdb-col>
        </mdb-row>

      </section>

      <div style="height: 5px"></div>
      <section class="mb-5" v-if="userDetails">
        <mdb-card cascade narrow>
          <section>
            <mdb-row>
              <mdb-col class="mr-0" md="12" xl="5">
                <mdb-card-body cascade class="pb-0">
                  <mdb-row class="card-body pt-3">
                    <mdb-col md="12">
                      <h4>
                      <span class="badge big-badge secondary-color"
                      >Date range</span
                      >
                      </h4>
                      <div class="md-form mb-5">
                        <datetime :auto="true" :format="userDetails.dateFormat"
                                  :valueZone="userDetails.timezone.ID"
                                  :week-start="userDetails.mondayFirst ? 1 : 7"
                                  :zone="userDetails.timezone.ID"
                                  inputId="from-input"
                                  v-model="dashboardData.filter.fromDate"></datetime>
                        <label class="active mr-5">From</label>
                      </div>
                      <div class="md-form mb-5">
                        <datetime :auto="true" :format="userDetails.dateFormat"
                                  :valueZone="userDetails.timezone.ID"
                                  :week-start="userDetails.mondayFirst ? 1 : 7"
                                  :zone="userDetails.timezone.ID"
                                  inputId="through-input"
                                  v-model="dashboardData.filter.throughDate"></datetime>
                        <label class="active mr-5">Through</label>
                      </div>
                      <mdb-btn @click="loadDashboard" icon="sync" rounded size="sm">Refresh</mdb-btn>
                    </mdb-col>
                    <!--/First column-->
                  </mdb-row>
                  <!--/Panel data-->
                </mdb-card-body>
                <!--/.Card content-->
              </mdb-col>
              <!--Grid column-->

              <!--Grid column-->
              <mdb-col class="mb-4" md="12" xl="7">
                <!--Card image-->
                <div class="view view-cascade gradient-card-header white">
                  <!-- Chart -->
                  <mdb-bar-chart :data="barChartData"
                                 :height="300"
                                 :options="barChartOptions"
                                 v-if="!$store.state.executing"
                  ></mdb-bar-chart>
                </div>
                <!--/Card image-->
              </mdb-col>
              <!--Grid column-->
            </mdb-row>
            <!--Grid row-->
          </section>
          <!--Section: Chart-->
        </mdb-card>
        <!--/.Card-->
      </section>
      <section class="mb-5">
        <mdb-row>
          <mdb-col class="mr-0" md="12" xl="12">
            <mdb-card>
              <mdb-card-body>
                <mdb-btn v-if="dashboardData.isAccountant" @click="openTransactions" icon="list" rounded size="sm">View
                  Transactions
                </mdb-btn>
                <mdb-btn @click="openSummary" icon="list" rounded size="sm">View
                  Summary
                </mdb-btn>
                <mdb-btn  v-if="dashboardData.isAccountant" @click="openCategories" icon="tasks" rounded size="sm">Setup Categories</mdb-btn>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </section>


    </div>
    <div class="text-left" v-if="showTransactions">
      <mdb-btn @click="closeTransactions" icon="arrow-left" rounded size="sm">Dashboard</mdb-btn>
      <mdb-btn @click="showSystemGenerated=false" icon="eye-slash"
               rounded size="sm"
               v-if="showSystemGenerated">Hide System Generated
      </mdb-btn>
      <mdb-btn @click="showSystemGenerated=true" icon="eye"
               rounded size="sm"
               v-if="!showSystemGenerated">Show System Generated
      </mdb-btn>
      <mdb-btn :disabled="categories.length==0"
               @click="newGroupTransaction"
               icon="plus-circle"
               rounded size="sm">Add {{ capitalize($tc("common.label.group",1)) }} Transaction
      </mdb-btn>

      <mdb-btn v-if="dashboardData.transactions.length > 0"
               @click="download"
               icon="download"
               rounded size="sm">Download Current List
      </mdb-btn>

      <small v-if="categories.length==0">You can add group transactions once you set up categories.</small>
      <member-lookup @selectedMember="newMemberTransaction"
                     input-label="Add Member Transaction"
                     input-placeholder="Member Name for New Transaction"
      />
      <mdb-card class="mt-2">
        <mdb-card-header class="secondary-color text-white text-center">
          <h4>Transaction History</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl responsive striped>
            <mdb-tbl-head color="primary-color" textWhite>
              <tr>
                <th>Date</th>
                <th>Category</th>
                <th>Member</th>
                <th>Description</th>
                <th>Income/<br/>Expense</th>
                <th>Amount</th>
                <th>Source</th>
                <th>Confirmation</th>
                <th>Recorded</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="t.id" v-for="(t,i) in dashboardData.transactions"
                  v-if="!t.systemGenerated || showSystemGenerated">
                <td>{{t.date}}</td>
                <td>{{t.categoryName}}</td>
                <td>{{t.memberName}}</td>
                <td v-if="editingTrans != i">{{t.description}} <span v-if="t.systemGenerated"><br/><mdb-badge>System Generated</mdb-badge></span>
                </td>
                <td v-if="editingTrans ==i">
                  <mdb-input v-model="workingTrans.description"/>
                </td>
                <td>{{t.categoryType}}</td>
                <td>{{t.amount}}</td>
                <td>{{t.source}}</td>
                <td>{{t.confirmationCode}}</td>
                <td>{{t.recordedBy}}<br/>{{t.recordedDate}}</td>
                <td>
                  <mdb-btn @click="deleteTrans(t)" color="danger" floating
                           type=""
                           icon="trash" size="sm" tag="a"
                           v-if="t.allowDelete"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="text-left" v-if="showCategories">
      <mdb-btn @click="closeCategories" icon="arrow-left" rounded size="sm">Dashboard</mdb-btn>
      <mdb-card class="mt-2">
        <mdb-card-header class="secondary-color text-white text-center">
          <h4>Categories
            <mdb-btn @click="addCategory" floating
                     type=""
                     icon="plus-circle" size="sm" tag="a"/>
          </h4>


        </mdb-card-header>
        <mdb-card-body>
          <small v-if="categories.length==0">
            Categories are used for general bookkeeping for your {{ $tc("common.label.group",1) }}
            (i.e., income and expenses not generated directly by {{ settings.siteName }}).
            <span v-if="!settings.disableGroupSubscriptions">
            "{{ capitalize($tc("common.label.member",1)) }} Transactions" is a system-defined category for payments (or adjustments)
            generated by the subscription plan payment page or the {{ capitalize($tc("common.label.event",1)) }} payment page.
            </span>
          </small>
          <mdb-tbl responsive striped>
            <mdb-tbl-head color="primary-color" textWhite>
              <tr>
                <th>Category</th>
                <th>Type</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="c.id" v-for="(c,i) in categories">
                <td v-if="editingCategory != i">{{c.name}}</td>
                <mdb-input placeholder="Enter category name" type="text" v-if="editingCategory==i"
                           v-model="workCategory.name"/>

                <td v-if="editingCategory != i">{{c.displayType}}</td>
                <td v-if="editingCategory==i">
                  <br/>
                  <select class="browser-default custom-select" id="category-drcr"
                          v-model="workCategory.type">
                    <option value="E">Expense</option>
                    <option value="I">Income</option>
                  </select>
                </td>

                <td v-if="editingCategory != i">
                  <mdb-btn @click="editCategory(c)" floating icon="pencil"
                           type=""
                           size="sm" tag="a"/>
                  <mdb-btn @click="deleteCategory(c)" color="danger"
                           type=""
                           floating icon="trash" size="sm" tag="a"/>
                </td>
                <td v-if="editingCategory==i">
                  <mdb-btn :disabled="!workCategory.name || !workCategory.type" @click="saveCategory" icon="save"
                           rounded
                           size="sm">Save
                  </mdb-btn>
                  <mdb-btn @click="cancelEditCategory" color="danger" icon="ban" rounded size="sm">Cancel</mdb-btn>
                </td>

              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
    </div>

    <div class="text-left" v-if="showSummary && summary">
      <mdb-btn @click="closeSummary" icon="arrow-left" rounded size="sm">Dashboard</mdb-btn>
      <mdb-card class="mb-2">
        <mdb-card-header class="primary-color text-white">
          <h4 class="centered">Income</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl responsive striped>
            <mdb-tbl-body>
              <tr>
                <td>{{ capitalize($tc("common.label.member",1)) }} Payments</td>
                <td class="text-right">{{summary.memberPaymentsTotal | formatNumber }}</td>
              </tr>
              <tr v-for="inc in summary.otherIncome">
                <td>{{inc.category}}</td>
                <td class="text-right">{{inc.total | formatNumber }}</td>
              </tr>
              <tr class="totals-row">
                <td>Total Income</td>
                <td class="text-right">{{summary.grossIncome | formatNumber }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-2">
        <mdb-card-header class="secondary-color text-white">
          <h4 class="centered">Expenses</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl responsive striped>
            <mdb-tbl-body>
              <tr v-for="exp in summary.otherExpenses">
                <td>{{exp.category}}</td>
                <td class="text-right">{{exp.total | formatNumber }}</td>
              </tr>

              <tr class="totals-row">
                <td>Total Expenses</td>
                <td class="text-right">{{summary.otherExpensesTotal | formatNumber }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-2">
        <mdb-card-header>
          <h4 class="centered">Summary of {{ capitalize($tc("common.label.member",1)) }} Charges</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl responsive striped>
            <mdb-tbl-body>
              <tr v-for="membership in summary.memberships">
                <td>{{membership.plan_name}}</td>
                <td class="text-right">{{membership.total_charge | formatNumber}}</td>
              </tr>
              <tr class="sub-totals-row">
                <td>Total {{ capitalize($tc("common.label.member",2)) }}</td>
                <td class="text-right">{{summary.membershipsTotal | formatNumber }}</td>
              </tr>
              <tr v-for="event in summary.events">
                <td>{{event.event_title}}</td>
                <td class="text-right">{{event.total_charge | formatNumber}}</td>
              </tr>

              <tr class="sub-totals-row">
                <td>Total {{ capitalize($tc("common.label.event",1)) }} Charges</td>
                <td class="text-right">{{summary.eventsTotal | formatNumber }}</td>
              </tr>
              <tr class="totals-row">
                <td>Grand Total Charges</td>
                <td class="text-right">{{summary.totalCharges | formatNumber }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>


    </div>

    <group-transaction :categories="categories"
                       :transaction="currentTransaction"
                       @transactionCanceled="groupTransactionCanceled"
                       @transactionSaved="groupTransactionSaved"
                       v-if="showGroupTransaction"/>

    <member-billing :create-only="true"
                    :group="currentGroup"
                    :member="selectedMember"
                    @transactionCanceled="newMemberCanceled" @transactionSaved="newMemberSaved"
                    v-if="showNewMemberTrans"/>

    <yes-no-modal :additional-text="deleteAdditionalText" :question="deleteQuestion" @no="showDeleteModal=false"
                  @yes="doDeleteAction"
                  v-if="showDeleteModal"
    />

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import {Datetime} from 'vue-datetime'
import MemberBilling from "./MemberBilling";
import MemberLookup from "../event/MemberLookup";
import YesNoModal from "../common/YesNoModal";
import groupTransaction from "./Transaction";
import moment from 'moment'
import download from 'js-file-download'
import {
  mdbBadge,
  mdbBarChart,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbDatePicker,
  mdbIcon,
  mdbInput,
  mdbRow,
  mdbSelect,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from "mdbvue";

export default {
    name: "group-accounting",
    order: 1,
    components: {
      mdbContainer,
      mdbIcon,
      mdbSelect,
      mdbBtn,
      mdbBadge,
      mdbDatePicker,
      mdbBarChart,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbTbl,
      mdbInput,
      mdbTblHead,
      mdbTblBody,
      bannerSmall,
      Datetime,
      MemberBilling,
      MemberLookup,
      YesNoModal,
      groupTransaction
    },
    computed: {
      currentGroup: function () {
        return this.$store.state.currentGroup
      },
      userDetails: function () {
        return this.$store.state.userDetails
      },
      settings: function () {
        return this.$store.state.settings
      }
    },
    data() {
      return {
        dashboardData: null,
        showSystemGenerated: false,
        showDashboard: true,
        showTransactions: false,
        showCategories: false,
        categories: [],
        barChartData: {
          labels: [],
          datasets: [
            {
              label: "Payment Sources",
              data: [],
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)"
              ],
              borderColor: [
                "rgba(255,99,132,1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)"
              ],
              borderWidth: 1
            }
          ]
        },
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                },
                ticks: {
                  fontColor: "black"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  fontColor: "black"
                }
              }
            ]
          },
          legend: {
            labels: {
              fontColor: "black"
            }
          }
        },
        showNewMemberTrans: false,
        showSummary: false,
        selectedMember: null,
        dataChanged: false,
        showDeleteModal: false,
        deleteMethod: null,
        deleteQuestion: "",
        deleteAdditionalText: "",
        deleteCandidate: null,
        editingCategory: null,
        workCategory: null,
        workingTrans: null,
        currentCategory: null,
        currentTransaction: null,
        showGroupTransaction: false,
        editingTrans: null,
        summary: null,
        topBoxSize: "3"
      }
    },
    mounted() {
      document.title = "Accounting"
      if (this.settings.disableGroupSubscriptions) this.topBoxSize = "4"
      this.loadDashboard()
    },
    filters: {
      formatNumber: function (val) {
        return val.toLocaleString(undefined, {minimumFractionDigits: 2})
      }
    },
    methods: {
      doDeleteAction() {
        this[this.deleteMethod]()
      },
      cancelEditCategory() {
        if (!this.workCategory.id) this.categories.splice(0, 1)
        this.editingCategory = null
      },
      editCategory(c) {
        this.workCategory = {id: c.id, name: c.name, type: c.type}
        this.currentCategory = c
        this.editingCategory = this.categories.indexOf(c)
      },
      editTrans(t) {
        this.workingTrans = JSON.parse(JSON.stringify(t))
        this.editingTrans = this.dashboardData.transactions.indexOf(t)
      },
      cancelEditTrans() {
        this.workingTrans = null;
        this.editingTrans = null;
      },
      addCategory() {
        this.workCategory = {id: null, name: "", type: "E"}
        this.categories.unshift({})
        this.editingCategory = 0
      },
      download() {
        let url = "/accounting/download/" + this.$route.params.id
        url += "?fromDate=" + this.dashboardData.filter.fromDate
        url += "&throughDate=" + this.dashboardData.filter.throughDate
        url += "&chargeOrCredit=" + this.dashboardData.filter.chargeOrCredit
        url = encodeURI(url)
        this.$store.dispatch("setExecuting", true)
        api.get(url).then(
          (results) => {
            download(results.data, "transactions.csv")
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      saveCategory() {
        let url = "/accounting/category/" + this.$route.params.id
        this.$store.dispatch("setExecuting", true)
        api.post(url, this.workCategory).then(
          (results) => {
            if (!this.workCategory.id) this.categories[0] = results.data
            else {
              let loc = this.categories.indexOf(this.currentCategory)
              this.categories[loc] = results.data
            }
            this.editingCategory = null
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      deleteCategory(c) {
        this.deleteCandidate = c
        this.deleteQuestion = "Are you sure you wish to delete category " + c.name + "?"
        this.deleteAdditionalText = "Existing transactions in this category will NOT be affected."
        this.showDeleteModal = true
        this.deleteMethod = "doDeleteCategory"
      },
      doDeleteCategory() {
        this.$store.dispatch("setExecuting", true)
        this.showDeleteModal = false
        let url = "/accounting/category/" + this.deleteCandidate.id
        api.delete(url).then(
          (results) => {
            let loc = this.categories.indexOf(this.deleteCandidate)
            this.categories.splice(loc, 1)
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },
      deleteTrans(c) {
        this.deleteCandidate = c
        this.deleteQuestion = "Are you sure you wish to delete this transaction?"
        this.deleteAdditionalText = ""
        this.showDeleteModal = true
        this.deleteMethod = "doDeleteTrans"
      },
      doDeleteTrans() {
        this.$store.dispatch("setExecuting", true)
        this.showDeleteModal = false
        let url = "/accounting/transaction/" + this.deleteCandidate.id
        api.delete(url).then(
          (results) => {
            let loc = this.dashboardData.transactions.indexOf(this.deleteCandidate)
            this.dashboardData.transactions.splice(loc, 1)
            this.dataChanged = true
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      newMemberTransaction(member) {
        this.selectedMember = member
        this.showNewMemberTrans = true
      },
      newMemberSaved(t) {
        this.dataChanged = true
        this.showNewMemberTrans = false
        let trans = t.transaction
        trans.categoryName = "Member Transactions"
        trans.type = "member"
        trans.amount = trans.amount * -1
        trans.systemGenerated = false
        trans.categoryType = "Income"
        trans.memberName = this.selectedMember.name
        trans.date = trans.displayDate
        this.dashboardData.transactions.unshift(trans)
      },
      newMemberCanceled() {
        this.showNewMemberTrans = false
        this.selectedMember = null
      },
      newGroupTransaction() {
        this.currentTransaction = {date: moment().format(), amount: null, category: null, description: ""}
        this.showGroupTransaction = true
      },
      groupTransactionSaved(t) {
        this.dataChanged = true
        this.dashboardData.transactions.unshift(t)
        this.currentTransaction = null
        this.showGroupTransaction = false
      },
      groupTransactionCanceled() {
        this.showGroupTransaction = false
        this.currentTransaction = null
      },
      openCategories() {
        this.showDashboard = false
        this.showCategories = true
        if (this.categories.length == 0) {
          let url = "/accounting/categories/" + this.$route.params.id
          this.$store.dispatch("setExecuting", true)
          api.get(url).then(
            (results) => {
              this.categories = results.data
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 20000})
            }).then(() => {
            this.$store.dispatch("setExecuting", false)
          })
        }
      },
      closeCategories() {
        this.showCategories = false
        this.showDashboard = true
      },
      openTransactions() {
        this.showDashboard = false
        this.showTransactions = true
        if (this.categories.length == 0) {
          let url = "/accounting/categories/" + this.$route.params.id
          api.get(url).then(
            (results) => {
              this.categories = results.data
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 20000})
            }).then(() => {
            this.$store.dispatch("setExecuting", false)
          })
        }
      },
      closeTransactions() {
        this.showTransactions = false
        if (this.dataChanged) this.loadDashboard()
        this.dataChanged = false
        this.showDashboard = true
      },
      openSummary() {
        this.showDashboard = false
        this.showSummary = true
        let url = "/accounting/summary/" + this.$route.params.id
        url += "?fromDate=" + this.dashboardData.filter.fromDate
        url += "&throughDate=" + this.dashboardData.filter.throughDate
        url = encodeURI(url)
        api.get(url).then(
          (results) => {
            this.summary = results.data
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },
      closeSummary() {
        this.showSummary = false
        this.showDashboard = true
      },
      loadDashboard() {
        this.$store.dispatch("setExecuting", true)
        let url = "/accounting/dashboard/" + this.$route.params.id
        if (this.dashboardData) {
          url += "?fromDate=" + this.dashboardData.filter.fromDate
          url += "&throughDate=" + this.dashboardData.filter.throughDate
          url += "&chargeOrCredit=" + this.dashboardData.filter.chargeOrCredit
          url = encodeURI(url)
        }
        api.get(url).then(
          (results) => {
            this.dashboardData = results.data
            this.barChartData.labels = []
            this.barChartData.datasets[0].data = []
            this.dateChanged = false
            for (let i = 0; i < results.data.sources.length; i++) {
              this.barChartData.labels.push(results.data.sources[i].category)
              this.barChartData.datasets[0].data.push(results.data.sources[i].amount)
            }
            if (!this.currentGroup || this.currentGroup.id != results.data.groupId) {
              api.groupBasics(results.data.groupId, "public");
            }
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000 })
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }
  };

</script>
<style lang="scss">
  @import '~vue-datetime/dist/vue-datetime.min';
</style>
